const fieldMapping = {
  "accountName": "Account Name",
  "businessDomain": "Company Website",
  "accountGrade": "Account Grade",
  "isActive": "Company Status",
  "sellerType": "Ad Inventory",
  "streetAddress": "Company Address",
  "city": "City",
  "region": "State/Region",
  "zipCode": "Zip Code/Postal Code"
}

const accountGrades = [
  { "name": "Grade A", "value": "GRADE_A" },
  { "name": "Grade B", "value": "GRADE_B" },
  { "name": "Grade C", "value": "GRADE_C" }
]

const sellerTypes = [
  { "name": "Publisher", "value": "PUBLISHER" },
  { "name": "Intermediary", "value": "INTERMEDIARY" },
  { "name": "Both", "value": "BOTH" }
]

const activeStatus = [
  { "name": "Active", "value": true },
  { "name": "Inactive", "value": false }
]

export { fieldMapping as FIELD_MAPPING }
export { accountGrades as ACCOUNT_GRADES };
export { sellerTypes as SELLER_TYPES };
export { activeStatus as ACTIVE_STATUS };